export default __webpack_public_path__ + "static/media/Group 3202.0287c435.jpg";